export default {
  isEmptyState(state) {
    return !(!!state.user || !!state.name);
  },
};
